import config from 'config';
import Styled from './styled';

const mailto = `mailto:${config.get('public.email.partners')}`;

export default function InterestedEmail() {
  return (
    <Styled>
      <strong>Interested in partnering with us?</strong>
      <br />
      <span>
        Email us at <a href={mailto}>{config.get('public.email.partners')}</a>
      </span>
    </Styled>
  );
}
